var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_vm._v(" Copyright© TAC Co.,Ltd. All Rights Reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }